import { useState, useCallback } from 'react'

interface ConfirmOptions {
    title: string
    description: string
    confirmText?: string
    cancelText?: string
    variant?: 'danger' | 'warning' | 'info'
}

export function useConfirm() {
    const [isOpen, setIsOpen] = useState(false)
    const [options, setOptions] = useState<ConfirmOptions>({
        title: '',
        description: ''
    })
    const [resolveReject, setResolveReject] = useState<{
        resolve: (value: boolean) => void
        reject: () => void
    } | null>(null)

    const confirm = useCallback((opts: ConfirmOptions): Promise<boolean> => {
        setOptions(opts)
        setIsOpen(true)

        return new Promise((resolve, reject) => {
            setResolveReject({ resolve, reject })
        })
    }, [])

    const handleConfirm = useCallback(() => {
        resolveReject?.resolve(true)
        setIsOpen(false)
    }, [resolveReject])

    const handleCancel = useCallback(() => {
        resolveReject?.resolve(false)
        setIsOpen(false)
    }, [resolveReject])

    return {
        confirm,
        isOpen,
        options,
        handleConfirm,
        handleCancel
    }
}
